import React from 'react';

import myxss from 'components/ReactFormBuilder/form-elements/myxss';

/**
 * Display screener/form footer.
 *
 * @param {string} html - Footer HTML
 */
export function ScreenerFooter({ html }) {
    return (
        <div
            className="account-email-footer color-text-secondary quill-render"
            dangerouslySetInnerHTML={{ __html: myxss.process(html) }}
        />
    );
}
